import React from "react";

export default function NcdSummary({ ncd }) {
  if (!ncd) return null;

  const items = [
    ["Doctor",         ncd.doctor_name],
    ["Condition",      ncd.condition],
    ["Duration",       ncd.diab_duration],
    ["HbA1c",          ncd.hba1c ?? "—"],
    ["Activity Level", ncd.lifestyle?.activity],
    ["Sleep Quality",  ncd.lifestyle?.sleep_quality],
    ["Eating Pattern", ncd.lifestyle?.eating_pattern],
    ["Target BMI",     ncd.targets?.bmi ? `${ncd.targets.bmi} (${ncd.targets.bmi_category})` : null],
    ["Daily Calories", ncd.targets?.target_calories ? `${ncd.targets.target_calories} kcal` : null],
    ["Protein",        ncd.targets?.protein_g ? `${ncd.targets.protein_g} g` : null],
    ["Carbs",          ncd.targets?.carbs_g   ? `${ncd.targets.carbs_g} g`   : null],
    ["Fat",            ncd.targets?.fat_g     ? `${ncd.targets.fat_g} g`     : null],
    ["Goal",           ncd.targets?.goal],
  ].filter(([, v]) => v);

  return (
    <div className="dv-ncd-grid">
      {items.map(([k, v]) => (
        <div key={k} className="dv-ncd-cell">
          <span className="dv-ncd-key">{k}</span>
          <span className="dv-ncd-val">{v}</span>
        </div>
      ))}
    </div>
  );
}